// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/base.css
// module id = 861
// module chunks = 41